// src/components/store/sections/product-cards/Variant53PerforatedPassCoralFlameCard.tsx
"use client";

import Image from "next/image";
import Link from "next/link";
import { Star, Ticket, ShoppingCart, Check } from "lucide-react";
import { UniversalProductCardProps, useCardActions } from "./useCardActions";

export default function Variant53PerforatedPassCoralFlameCard({
  product,
  subdomain = "nextlook",
}: UniversalProductCardProps) {
  const {
    productImg,
    productName,
    productUrl,
    categoryName,
    rating,
    currentPrice,
    discountPercent,
    added,
    handleAddToCart,
  } = useCardActions(product, subdomain);

  return (
    <div className="w-full h-full bg-white rounded-3xl border-2 border-orange-200 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col justify-between group select-none">
      <div>
        <div className="px-4 py-2 bg-gradient-to-r from-orange-500 to-red-600 text-white flex items-center justify-between text-[10px] font-mono font-black uppercase">
          <span className="flex items-center gap-1"><Ticket className="w-3.5 h-3.5" /> VIP #53</span>
          <span>SAVE {discountPercent}%</span>
        </div>
        <div className="p-4 pb-2">
          <Link href={productUrl} className="relative w-full h-40 rounded-2xl bg-orange-50 flex items-center justify-center p-3 mb-2.5 block">
            <Image src={productImg} alt={productName} fill unoptimized className="object-contain p-2 group-hover:scale-105 transition-transform" />
          </Link>
          <div className="flex items-center justify-between text-[10px] font-bold text-slate-400">
            <span className="truncate max-w-[120px] uppercase">{categoryName}</span>
            <span className="flex items-center gap-0.5 text-amber-500">
              <Star className="w-3 h-3 fill-amber-400" /> {rating.toFixed(1)}
            </span>
          </div>
          <Link href={productUrl} className="block mt-0.5">
            <h3 className="text-sm font-black text-slate-900 truncate hover:underline">{productName}</h3>
          </Link>
        </div>
      </div>

      <div className="relative flex items-center justify-between my-1">
        <div className="w-4 h-4 rounded-full bg-slate-100 border-r-2 border-orange-200 -ml-2" />
        <div className="w-full border-t-2 border-dashed border-orange-200 mx-1" />
        <div className="w-4 h-4 rounded-full bg-slate-100 border-l-2 border-orange-200 -mr-2" />
      </div>

      <div className="p-4 pt-2 flex items-center justify-between gap-2 bg-orange-50">
        <div>
          <span className="text-[8px] font-mono uppercase text-slate-400 block">PASS PRICE</span>
          <span className="text-base font-black font-mono text-orange-700">৳{currentPrice.toLocaleString()}</span>
        </div>
        <button
          type="button"
          onClick={(e) => handleAddToCart(e)}
          className="px-3.5 py-2 rounded-xl bg-red-600 hover:bg-red-700 text-white font-black text-[10px] uppercase tracking-wider shadow-xs active:scale-95 transition-all cursor-pointer flex items-center gap-1"
        >
          {added ? <Check className="w-3.5 h-3.5" /> : <ShoppingCart className="w-3.5 h-3.5" />}
          <span>{added ? "Claimed" : "Claim"}</span>
        </button>
      </div>
    </div>
  );
}
